import './style.scss';
import { Box, Typography } from '@mui/material';
import { useLanguageContext } from '../../../../../contexts/LanguageContext';
import ScrollableX from '../../../../../components/ScrollableX';
import { WebsiteConstants } from '../../../../../data/Constants';
import Card from '../../../../../components/Card';
import { useNavigate } from 'react-router-dom';


const OtherDestinations = () => {
    const { translate } = useLanguageContext();
    const navigate = useNavigate();


    return <Box className='grid-content-section' id='otherDestinations'>
        <Typography variant='subtitle1' className='otherDestinations-title'>{translate('otherDestinationsTitle')}</Typography>
        <Typography variant='subtitle2' className='otherDestinations-description'>{translate('otherDestinationsDescription')}</Typography>

        <Box className='otherDestinations-items'>
            <ScrollableX hasContainer={false}>
                {
                    WebsiteConstants.otherDestinations.map((d, index) => {
                        return <Card 
                            chip={d.state}
                            image={d.wallpaper}
                            title={d.city}
                            variant='wallpaper'
                            key={index}
                            className='width-lg'
                            onClick={() => navigate(`/${d.key}`)}
                        />;
                    })
                }
            </ScrollableX>
        </Box>
    </Box>;
}

export default OtherDestinations;